
export const fieldNames = {
  DISPLAYNAME: "displayName",

};

 const validateDisplayName = (props: any) => {
  const { validate, model } = props;

  if (!validate.displayName) {
    validate.displayName = {
      touched: true,
      error: false,
    };
  }
  validate.displayName.message = "";

  if (!model.displayName) {
    validate.displayName.message = "validate_required";
    validate.displayName.error = true;
    return validate;
  }

  validate.displayName.message = "";
  validate.displayName.error = false;
  return validate;
};


export const validateStep = (model: any, validate: any, el: any) => {
  return {
    ...validateDisplayName({ model, validate }),
  };
};